import React, { useContext, useMemo } from 'react';
import Step from '../Step/Step';
import SetOfCircleIcons from 'commonComponents/icons/SetOfCircleIcons/SetOfCircleIcons';
import { getIcons } from '../../../images';
import { LegendContext } from '../../Transfer';
import classNames from 'classnames';
import styles from './StepWithIcon.module.scss';

/*eslint max-lines-per-function: ["error", 200]*/
const StepWithIcon = ({ step, params, number, rendered, getPosition }) => {
  const stepProps = { ...step, params, number, rendered, getPosition };
  const iconNames = Object.keys(params).filter((name) => params[name]);
  const legend = useContext(LegendContext);
  const icons = getIcons(iconNames, legend);

  const classes = useMemo(() => {
    return (
      classNames({
        [styles.StepWithIcon]: true,
        [styles[`Step${stepProps.number}`]]: true,
      }));
  }, [styles, stepProps.number]);

  const iconRender = useMemo(() => {
    return (
      params.selected ? (
        <img src={icons[0].src} width="100"
          alt="icon"
        />
      ) : (
        <SetOfCircleIcons
          icons={icons}
          rendered={rendered}
          additionalClass={styles.icons}
        />
      ));
  }, [icons, rendered]);

  return (
    <div className={classes}>
      <Step key={step.text || step} {...stepProps} />
      <div className={styles.iconsSet}>{iconRender}</div>
    </div>
  );
};

export default StepWithIcon;
